import {
  AnalyticsAPI,
  RunPendingCallsConfig,
  CallType,
  TrackCall,
  IdentifyCall
} from "../analytics.model";
import { Store } from "../libs/store";

const PENDING_TRACK_CALLS_KEY = "LC:PendingTrackCalls";
const PENDING_IDENTIFY_CALLS_KEY = "LC:PendingIdentifyCalls";
const STORAGE_KEYS: { [key: string]: string } = {
  track: PENDING_TRACK_CALLS_KEY,
  identify: PENDING_IDENTIFY_CALLS_KEY
};

const runPendingCalls = (store: Store, type: "track" | "identify") => {
  const pendingCalls = JSON.parse(store.read(STORAGE_KEYS[type]));
  if (pendingCalls && pendingCalls.length) {
    switch (type) {
      case CallType.Track:
        pendingCalls.forEach((pendingCall: TrackCall) => {
          (window as any).analytics.track(
            pendingCall.eventName,
            pendingCall.eventProperties
          );
        });
        break;
      case CallType.Identify:
        pendingCalls.forEach((pendingCall: IdentifyCall) => {
          (window as any).analytics.identify(
            pendingCall.userId,
            pendingCall.userProperties
          );
        });
        break;
    }
    store.remove(STORAGE_KEYS[type]);
  }
};

const registerPendingCall = (
  store: Store,
  type: "track" | "identify",
  callObj: any
) => {
  let pendingCalls = JSON.parse(store.read(STORAGE_KEYS[type]));
  pendingCalls ? pendingCalls.push(callObj) : (pendingCalls = [callObj]);
  store.write(STORAGE_KEYS[type], JSON.stringify(pendingCalls));
};

export class SegmentAnalyitcs implements AnalyticsAPI {
  constructor(private store: Store) {
    runPendingCalls(store, "track");
    runPendingCalls(store, "identify");
  }

  test(): boolean {
    const analytics = (window as any).analytics;

    if (typeof analytics === "undefined") return false;

    return (
      (typeof analytics === "object" && analytics.Integrations) ||
      (analytics.methods && typeof analytics.Integrations === "object") ||
      typeof analytics.methods === "object"
    );
  }

  identify(userId: string, userProperties: any, isLazy: boolean) {
    isLazy
      ? registerPendingCall(this.store, "identify", { userId, userProperties })
      : (window as any).analytics.identify(userId, userProperties);
  }

  track(eventName: string, eventProperties: any, isLazy: boolean) {
    isLazy
      ? registerPendingCall(this.store, "track", { eventName, eventProperties })
      : (window as any).analytics.track(eventName, eventProperties);
  }

  page(category: string, name: string, properties: any) {
    (window as any).analytics.page(category, name, properties);
  }

  alias(userId: string, previousId: string) {
    (window as any).analytics.alias(userId, previousId);
  }

  group(groupId: string, traits: any) {
    (window as any).analytics.group(groupId, traits);
  }

  clearPendingCalls() {
    Object.keys(STORAGE_KEYS).forEach(key => {
      this.store.remove(STORAGE_KEYS[key]);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/segment.ts